import { ListChargersV2Charger } from 'src/@types/shared';

export const convertSiteAddress = (data: ListChargersV2Charger) => {
  return `${data?.site?.address1 || ''} ${data?.site?.address2 || ''} ${data?.site?.locality || ''} ${
    data?.site?.administrativeArea || ''
  } ${data?.site?.postalCode || ''}`
    .replace(/\s+/g, ' ')
    .trim();
};
